import { useMemo } from 'react';
import styled from 'styled-components';

type FinishOfferBulkImportProps = {
  totalCreated: number;
  errorsCount: number;
};

export function FinishOfferBulkImport({
  totalCreated,
  errorsCount,
}: FinishOfferBulkImportProps) {
  const hasErrors = errorsCount > 0;

  const titleImports = useMemo(() => {
    if (hasErrors) {
      if (totalCreated > 0) {
        return 'Importação concluída com ressalvas';
      }
      return 'Nenhuma oferta foi importada';
    }
    return 'Todas as ofertas foram importadas com sucesso';
  }, [hasErrors, totalCreated]);

  const labelImports = useMemo(() => {
    if (hasErrors) {
      if (totalCreated > 0) {
        return `${totalCreated} oferta(s) importada(s) com sucesso, mas ${errorsCount} oferta(s) não foram importadas.`;
      }
      return `Verifique as instruções de preenchimento e tente novamente.`;
    }
    return `${totalCreated} oferta(s) importada(s) com sucesso.`;
  }, [hasErrors, totalCreated, errorsCount]);

  return (
    <Container>
      <Title>{titleImports}</Title>
      <Text>{labelImports}</Text>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #ffffff;
  margin-top: 30vh;
`;

const Title = styled.h2`
  font-weight: 590;
  font-size: 20px;
  line-height: 28px;
`;

const Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;
